<template>
	<sf-data-table
		ref="pprNoTable"
		:pageUnit="this.pprNoPagingInfo.pageUnit"
		:totalSize="this.pprNoPagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="pprNoPopupList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
		fit="fit"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PrtRpt/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// 품번
					label: this.getMessage_('QWCC000956'),
					prop: 'partNo',
					minWidth: '150px',
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					// 품명
					label: this.getMessage_('QWCC000957'),
					prop: 'partNm',
					minWidth: '150px'
				},
				{
					// ppr번호
					label: this.getMessage_('QWCC001034'),
					prop: 'pprNo',
					minWidth: '150px'
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			// console.log('currentPageVal, pageUnitVal, prePage, prePageUnit >>>', currentPageVal, pageUnitVal, prePage, prePageUnit);
			this.setPprNoPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPprNoPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload');
		},
		scrNameClick(row) {
			//this.editRow = row;
			this.$emit('SendData', row);
		}
	}
};
</script>

<style></style>
